
<template>
    <div class="seckillTop">
        <div class="storeName">{{ store_name }}</div>
        <div class="share" @click="onShare($event)">
            <shareBox ref="shareBox" :shareInfo="share">
                <i class="ico ico-icon_56" data-flag="shareBox"></i>
            </shareBox>
        </div>
        <div class="explan" @click="onShowExplan">
            <span>活动说明</span>
        </div>
        <img :src="topicImg" @error="onTopicImg">
    </div>
</template>

<script>
import shareBox from '@/components/share/share.vue'
export default {
    name: 'seckillTop',
    props: {
        store_name: {
            type: String,
            default: ''
        },
        topic_img: {
            type: String,
            default: 'https://image.carisok.com/images/seckill_banner_default.png'
        },
        topic_explain: {
            type: String,
            default: ''
        },
        share: {
            type: Object,
            default: () => {
                return {
                    title: '分享标题',
                    desc: '分享描述',
                    imgUrl: '分享图片',
                }
            }
        }
    },
    components: {
        shareBox
    },
    data () {
        return {
            selectIndex: 0, // 当前选择的索引
            topicImg: '', // 顶部图片
        }
    },
    created () {

    },
    activated () {

    },
    watch:{
        topic_img: {
            handler (newValue) {
                this.topicImg = newValue
            }
        },
    },
    mounted () {
    },
    methods: {
        onTopicImg (e) {
            this.topicImg = 'https://image.carisok.com/images/seckill_banner_default.png'
        },
        /**
         * 分享
         */
        onShare (e) {
            /* 阻止子元素不触发父元素事件 */
            if (e.target.getAttribute('data-flag') === 'shareBox') {
                this.$refs.shareBox.show()
            }
        },
        /**
         * 显示活动说明
         */
        onShowExplan () {
            this.$dialog.alert({
                message: this.topic_explain,
                confirmButtonText: '关闭'
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../../assets/stylus/variables'
@import '~@/assets/stylus/mixin.styl'
.seckillTop
    width 100%
    position relative
    height 350px
    overflow hidden
    .storeName
        position absolute
        top 36px
        left 30px
        color #fff
        font-size 30px
        width 50%
        textOverflow()
    .share
        position absolute
        top 27px
        right 30px
    .explan
        position absolute
        bottom 30px
        right 0
        display inline-block
        font-size 24px
        color #fff
        height 36px
        line-height 36px
        background-color rgba(0, 0, 0, 0.5)
        border-radius 17px 0px 0px 17px
        padding 0 18px 0 18px
</style>
